module.exports = __webpack_public_path__ + "img/map_courses.8446219c.svg";